import { useState, useCallback } from "react";
import { differentialExpressionDefaults } from "../../../config/plotConfigs/differentialExpressionConfig";

export const useDifferentialSettings = () => {
  const [settings, setSettings] = useState(differentialExpressionDefaults);

  const updateSetting = useCallback((key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const updateMultipleSettings = useCallback((newSettings) => {
    setSettings((prev) => ({
      ...prev,
      ...newSettings,
    }));
  }, []);

  const resetSettings = useCallback(() => {
    setSettings(differentialExpressionDefaults);
  }, []);

  const validateSettings = useCallback(() => {
    const errors = [];

    if (settings.maxPadj < 0 || settings.maxPadj > 100) {
      errors.push("Max padj must be between 0 and 100");
    }

    // Validate plot scale ranges if provided
    if (
      settings.xMin !== "" &&
      settings.xMax !== "" &&
      parseFloat(settings.xMin) >= parseFloat(settings.xMax)
    ) {
      errors.push("X-axis minimum must be less than maximum");
    }

    if (
      settings.yMin !== "" &&
      settings.yMax !== "" &&
      parseFloat(settings.yMin) >= parseFloat(settings.yMax)
    ) {
      errors.push("Y-axis minimum must be less than maximum");
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }, [settings]);

  return {
    settings,
    updateSetting,
    updateMultipleSettings,
    resetSettings,
    validateSettings,
  };
};
